document.addEventListener("DOMContentLoaded", function() {

    let brands_blocks = document.querySelectorAll('.block.brands');

    brands_blocks.forEach(block => {

        let brands_selector = block.querySelector('.brands--brands_selector');
        let brands_tab = block.querySelectorAll('.brands--brands_list_item');

        brands_selector.addEventListener('change', function(event) {
            event.preventDefault();

            brands_tab.forEach(tab => {
                tab.style.display = 'none';
            });

            let target_id = event.target.value;
            let target_tab = document.getElementById(target_id);

            if (target_tab) {
                window.helpers.fadeIn(target_tab);
                window.helpers.scrollToTarget( event.target.value );
            }
            
        });

    });
});